//import React from 'react';
import { useEffect } from 'react';

/**
 * SEO component for dynamically updating page metadata
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @param {string} props.keywords - Page keywords
 * @param {string} props.ogImage - Open Graph image URL
 * @param {string} props.url - Canonical URL
 */
const SEO = ({ 
  title = 'Cloud POS System Malaysia | Retail, F&B, Salon | VernPOS',
  description = 'Discover VernPOS, the top-rated cloud POS system in Malaysia. Perfect for retail, F&B, and service businesses. Easy to use, powerful features. Learn more!',
  keywords = 'POS Malaysia, cloud POS system, retail POS Malaysia, F&B POS, salon POS, restaurant POS Malaysia, kedai POS system, sistem POS, inventory management, Vern POS, business solutions Malaysia',
  ogImage = '/og-image.jpg',
  url = 'https://vernpos.my/'
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta tags
    const metaTags = {
      'description': description,
      'keywords': keywords,
      'og:title': title,
      'og:description': description,
      'og:image': ogImage,
      'og:url': url,
      'twitter:title': title,
      'twitter:description': description,
      'twitter:image': ogImage,
      'twitter:url': url
    };
    
    // Update or create meta tags
    Object.entries(metaTags).forEach(([name, content]) => {
      let metaTag = document.querySelector(`meta[property="${name}"]`) || 
                   document.querySelector(`meta[name="${name}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        if (name.startsWith('og:') || name.startsWith('twitter:')) {
          metaTag.setAttribute('property', name);
        } else {
          metaTag.setAttribute('name', name);
        }
        document.head.appendChild(metaTag);
      }
      
      metaTag.setAttribute('content', content);
    });
    
    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', url);
    
    // Cleanup function
    return () => {
      // No cleanup needed as we're just updating meta tags
    };
  }, [title, description, keywords, ogImage, url]);
  
  // This component doesn't render anything
  return null;
};

export default SEO;
